import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import { LabelUpdatesSocketMessage, OnLabelUpdatesSocketEvent } from './types';

export function useSocketLabelUpdateListener(
  onEvent: OnLabelUpdatesSocketEvent
) {
  const channel = useGetSocketChannel(SocketMessageType.LABEL_UPDATE);

  useSocketEvent(channel, (data: LabelUpdatesSocketMessage) => {
    if (data.type === SocketMessageType.LABEL_UPDATE) onEvent(data);
  });
}
